













import { Component, Mixins, Prop } from "vue-property-decorator";
import { SingleSelectableMixin } from "./mixins";

@Component({
})
export default class TabSelector extends Mixins(SingleSelectableMixin) {
  @Prop({ default: "top" })
  position: string;

  @Prop()
  isDeselectable: boolean;

  toTabClass(value: any): string {
    return (this.selectedOption === value)
      ? this.position + " selected"
      : this.position;
  }

  selectTab(value: any): void {
    if (this.selectedOption === value) {
      if (this.isDeselectable) {
        this.selectedOption = null;
      }
    } else {
      this.selectedOption = value;
    }
  }
}
